import React from 'react';
import { Content as ContentLayout } from 'components/layouts/content';
import { isProspectMode } from 'selectors/user/user-features-selector';
import { NavBarWrapper } from './secondary-nav-bar.styled';
import { useSelector } from 'react-redux';

const SecondaryNavBar = ({ children, ...properties }) => {
    const prospectMode = useSelector(isProspectMode);

    return (
        // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
        <NavBarWrapper prospectMode={prospectMode} {...properties}>
            {!!prospectMode ? (
                <ContentLayout>{children}</ContentLayout>
            ) : (
                <ContentLayout inline fixed>
                    {children}
                </ContentLayout>
            )}
        </NavBarWrapper>
    );
};

export default SecondaryNavBar;
